import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import './styles.scss'
import { setActiveChannel, setActiveUser } from 'redux/actions/tabs'
import inchatActions from 'redux/inchat/actions'
import { Button } from 'components/Form'
import ModalDelete from 'components/ModalDelete'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'
import { DateTime } from 'luxon'

const ScheduledContent = () => {
  const { inchat } = useSelector(store => store)
  const scheduled = inchat.scheduled || {}
  const conversations = inchat.conversations
  const dispatch = useDispatch()
  const { push } = useHistory()
  const [messageToDelete, setMessageToDelete] = useState({})
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)

  useEffect(() => {
    return () => {/* Restablecer diferidos y contador al desmontar */}
  }, [])

  const toggleDeleteModal = message => {
    if (!isOpenDeleteModal) {
      setMessageToDelete(message)
    } else {
      setMessageToDelete({})
    }
    setIsOpenDeleteModal(prevState => !prevState)
  }

  const handleEdit = message => {
    const conversation = message.conversation

    dispatch(setActiveChannel('inchat'))
    dispatch(setActiveUser(conversation._id))
    dispatch(inchatActions.setScheduledMessageToEdit({
      conversationId: conversation._id,
      id: message._id,
      date: message.scheduledAt
    }))
    if (!conversations[conversation._id]) {
      dispatch(inchatActions.addConversations({
        _id: conversation._id,
        channel: 'inChat',
        provider: 'inChat',
        private: conversation.private,
        users: conversation.users,
        type: conversation.type,
        usersInfo: conversation.usersInfo
      }))
    }
    dispatch(inchatActions.editMessage({ message: message.content }))
    dispatch(inchatActions.editMessageAddAttachments(conversation._id, message.attachments))
    push({
      pathname: '/dashboard/conversations/inchat',
      search: `?user_id=${conversation._id}`
    })
  }

  const handleDelete = () => {
    dispatch(inchatActions.deleteScheduleMessage({
      data: messageToDelete,
      onFinish: toggleDeleteModal
    }))
  }

  return (
    <div className='inchat-scheduled-messages'>
      {!scheduled.count ? (
        <div className='no-content'>
          <img src={getStaticImage('/icons/orange-brand/icon-empty.svg')} alt='Empty' />
          <span>{lang('dashboard_no-scheduled-messages')}</span>
        </div>
      ) : scheduled.data.map((message, index) => {
        const users = message.conversation?.usersInfo || []
        return (
          <div key={index} className='inchat-scheduled-messages__message'>
            <div className='inchat-scheduled-messages__picture-container'>
              {users.map((user, index) => index <= 3 && (
                <figure
                  key={index}
                  className={`
                    inchat-scheduled-messages__picture
                    ${users.length > 1 ? 'inchat-scheduled-messages__picture--small' : ''}
                  `}
                >
                  <img
                    src={user.picture || getStaticImage('/icons/orange-brand/icon-avatar.svg')}
                    alt={`${user.name} ${user.lastname}`}
                    onError={event => event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')}
                  />
                </figure>
              ))}
            </div>
            <div className='inchat-scheduled-messages__info'>
              <div className='inchat-scheduled-messages__info-header'>
                <strong className='inchat-scheduled-messages__name text-ellipsis'>
                  {[].concat(users.map(user => `${user.name} ${user.lastname}`)).join(', ')}
                </strong>
                <span className='inchat-scheduled-messages__date'>
                  {DateTime.fromISO(message.scheduledAt).setLocale('es-ES').toFormat('DD, T')}
                </span>
              </div>
              <div className='inchat-scheduled-messages__content'>
                <p className='inchat-scheduled-messages__text'>{message.content}</p>
                <div className='inchat-scheduled-messages__actions'>
                  <button
                    title={lang('dashboard_edit')}
                    className='inchat-scheduled-messages__action-btn'
                    onClick={() => handleEdit(message)}
                  >
                    <figure>
                      <img src={getStaticImage('/icons/orange-brand/icon-edit.svg')} alt='Edit' />
                    </figure>
                  </button>
                  <button
                    title={lang('dashboard_delete')}
                    className='inchat-scheduled-messages__action-btn'
                    onClick={() => toggleDeleteModal({
                      id: message._id,
                      conversationId: message.conversation._id
                    })}
                  >
                    <figure>
                      <img src={getStaticImage('/icons/orange-brand/icon-delete.svg')} alt='Delete' />
                    </figure>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      })}
      {(scheduled.loading || (scheduled.count >= scheduled.limit && !scheduled.isAll)) ? (
        <Button
          clearPrimary
          className='inchat-scheduled-messages__btn'
          value={lang('dashboard_load-more')}
          onClick={() => dispatch(inchatActions.getMoreMessages())}
          isSubmitting={scheduled.loading}
        />
      ) : null}

      {/* Delete modal */}
      <ModalDelete
        isOpen={isOpenDeleteModal}
        toggle={toggleDeleteModal}
        event={handleDelete}
        header={lang('dashboard_delete-schedule-message')}
        text1={lang('dashboard_delete-schedule-message-confirm')}
        text2={lang('dashboard_action-cannot-reversed')}
        isSubmitting={scheduled.deleting}
      />
    </div>
  )
}

export default ScheduledContent
